// extracted by mini-css-extract-plugin
export var attachmentContainer = "_j3-0";
export var fileList = "_j3-2";
export var removeFileButton = "_j3-1";